import React from 'react'
import type { Tabs } from '@core/Areas/Account/Pages/Activity/types'
import { KAMBI_PENDING_HASH_ROUTE } from '@core/Areas/KambiClient/constants'
import {
  RacingTransactionTitleStyled,
  TransactionTabStyled as Tab,
  TransactionTabActiveStyled as TabActive,
  TransactionTabsStyled as TransactionTabs,
} from './RacingSportsTabs.styles'

type ActiveTabs = Tabs | 'sports'

const racingTabs: ActiveTabs[] = ['pending', 'results', 'rebet']

export const RacingSportsTabs: React.FC<{ activeTab: ActiveTabs; isRacing?: boolean }> = ({
  isRacing,
  activeTab,
}) => {
  const RacingTab = racingTabs.includes(activeTab) ? TabActive : Tab
  const SportsTab = activeTab === 'sports' ? TabActive : Tab
  return (
    <>
      <TransactionTabs>
        <RacingTab data-testid='account-activity-tab-racing' to='/account/activity/pending'>
          Racing Bets
        </RacingTab>

        <SportsTab data-testid='account-activity-tab-sports' to={`${KAMBI_PENDING_HASH_ROUTE}`}>
          Sports Bets
        </SportsTab>
      </TransactionTabs>

      {isRacing && (
        <RacingTransactionTitleStyled>
          <h1 data-testid='account-activity-transactions-title'>
            My {activeTab === 'transactions' ? 'Debit / Credit' : 'Racing Bets'}
          </h1>
        </RacingTransactionTitleStyled>
      )}
    </>
  )
}
